import React, { useCallback } from "react";
import { useSelector, useStore, useDispatch } from "react-redux";
import { isEmpty } from "lodash-es";
import { Scrollbars } from "react-custom-scrollbars-2";
import RouteItem from "./RouteItem";
import styles from "./index.module.less";

function NavigatePanel() {
  const { select } = useStore();
  const dispatch = useDispatch();
  const passages = useSelector(select.layer.selectPassages);
  const active = useCallback(
    (id) => {
      dispatch.layer.activePassage({ id });
    },
    [dispatch]
  );
  if (isEmpty(passages)) return null;
  const items = passages.map((item, index) => (
    <RouteItem key={`route-item-${index}`} active={active} item={item} />
  ));
  return (
    <div className={styles.navigatePanel}>
      <Scrollbars style={{ height: "100%" }}>{items}</Scrollbars>
    </div>
  );
}

export default NavigatePanel;
